/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Untitledsession1Inputs */

const zh_learn_untitledsession1 = /** @type {(inputs: Learn_Untitledsession1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未命名资源`)
};

const en_learn_untitledsession1 = /** @type {(inputs: Learn_Untitledsession1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untitled Resource`)
};

const es_learn_untitledsession1 = /** @type {(inputs: Learn_Untitledsession1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recurso sin título`)
};

/**
* | output |
* | --- |
* | "Untitled Resource" |
*
* @param {Learn_Untitledsession1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_untitledsession1 = /** @type {((inputs?: Learn_Untitledsession1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Untitledsession1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_untitledsession1(inputs)
	if (locale === "en") return en_learn_untitledsession1(inputs)
	return es_learn_untitledsession1(inputs)
});
export { learn_untitledsession1 as "learn_untitledSession" }